import { create } from 'zustand';

const useUIStore = create((set) => ({
    // Module sidebar (left, main nav)
    sidebarCollapsed: false,
    setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
    toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
    // Feature sidebar (second, module sub-nav)
    featureSidebarCollapsed: false,
    setFeatureSidebarCollapsed: (collapsed) => set({ featureSidebarCollapsed: collapsed }),
    toggleFeatureSidebar: () => set((state) => ({ featureSidebarCollapsed: !state.featureSidebarCollapsed })),
}));

export default useUIStore;
